import { useNavigate } from 'react-router-dom';
import { mainSiteUrl } from '@/mocks/categories';

export default function Hero() {
  const navigate = useNavigate();

  return (
    <section className="relative w-full min-h-[600px] md:min-h-[700px] flex items-center overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=Expansive%20modern%20fashion%20boutique%20interior%20with%20minimalist%20shelving%20displaying%20clothing%20and%20accessories%2C%20warm%20ambient%20lighting%2C%20cream%20and%20natural%20wood%20tones%2C%20clean%20editorial%20retail%20photography%2C%20luxury%20shopping%20atmosphere%2C%20soft%20golden%20highlights&width=1600&height=900&seq=hero-bg-unique&orientation=landscape"
          alt="Basetao Spreadsheet lifestyle background"
          className="w-full h-full object-cover object-center"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/35 via-black/20 to-black/35"></div>
      </div>

      <div className="relative z-10 w-full max-w-7xl mx-auto px-4 md:px-6 py-20 md:py-28">
        <div className="max-w-2xl">
          <div className="inline-flex items-center gap-2 px-3 py-1.5 bg-white/90 backdrop-blur-sm rounded-full mb-6">
            <span className="w-2 h-2 rounded-full bg-primary-500"></span>
            <span className="text-xs font-medium text-foreground-700">Updated 2026 Resource Hub</span>
          </div>

          <h1 className="text-3xl md:text-5xl lg:text-6xl font-heading font-bold text-white leading-tight mb-5">
            Basetao Spreadsheet:<br />The Complete Guide To<br />Smarter Shopping
          </h1>

          <p className="text-base md:text-lg text-white/85 max-w-lg mb-8 leading-relaxed">
            Explore the latest Basetao Spreadsheet resources including product finds, quality checks, shipping cost guides, discount information, warehouse tips, and expert reviews.
          </p>

          <div className="flex flex-col sm:flex-row items-start gap-3">
            <a
              href={mainSiteUrl}
              target="_blank"
              rel="noopener nofollow"
              className="px-7 py-3.5 bg-primary-500 text-white font-medium rounded-md hover:bg-primary-600 transition-all duration-200 text-sm whitespace-nowrap cursor-pointer"
            >
              Spreadsheet
            </a>
            <a
              href={mainSiteUrl}
              target="_blank"
              rel="noopener nofollow"
              className="px-7 py-3.5 bg-white/90 backdrop-blur-sm text-foreground-900 font-medium rounded-md hover:bg-white transition-all duration-200 text-sm whitespace-nowrap cursor-pointer"
            >
              Buy It Now
            </a>
            <button
              onClick={() => navigate('/basetao-spreadsheet-guide')}
              className="px-7 py-3.5 border border-white/40 text-white font-medium rounded-md hover:bg-white/10 transition-all duration-200 text-sm whitespace-nowrap cursor-pointer"
            >
              Read Full Guide
            </button>
          </div>

          <div className="flex flex-wrap items-center gap-4 md:gap-6 mt-8">
            {['Updated Resources', 'Detailed Buying Guides', 'Shipping Information', 'Safety Recommendations'].map((badge) => (
              <span key={badge} className="flex items-center gap-1.5 text-xs text-white/75">
                <i className="ri-check-line text-primary-400"></i>
                {badge}
              </span>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}